export default __webpack_public_path__ + "static/media/spectra-com13.0b8b1f64.jpg";